export default "__VITE_ASSET__055302a3__"